module.exports = __webpack_public_path__ + "img/engineer-badge.916d6385.png";